import React from "react";
import "./Spinner.css";

interface SpinnerProps {
  size?: number;
}

const Spinner: React.FC<SpinnerProps> = ({ size = 40 }) => {
  return (
    <div className="spinner-wrapper">
      <div
        className="spinner"
        style={{
          width: size,
          height: size,
        }}
      />
    </div>
  );
};

export default Spinner;
